import React from 'react';
import ReactDOM from 'react-dom';
import RoutePage from './RoutePage';
import reportWebVitals from './reportWebVitals';
import './assets/main.scss';
import 'lazysizes';

ReactDOM.render(
  <React.StrictMode>
    <RoutePage />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
